import { createFileRoute } from '@tanstack/react-router';
import { ReferCodePage } from './ReferCodePage';

export const Route = createFileRoute('/_protected/_consumer/refer-friends/code/')({
  component: ReferCodePage,
});
